import { CCol, CRow } from '@coreui/react';

const FleetDashboardTabs = ({
  title,
  fleetTabs,
  handleActiveTab,
  activeTab,
  onAddVehicle,
  badge,
  disable,
}) => {
  const handleTab = (i) => {
    handleActiveTab(i);
  };

  return (
    <div>
      <CRow className="p-0">
        <CCol>
          <div className="dashboard-links">
            {fleetTabs?.map((link, index) => (
              <div key={index}>
                <div
                  onClick={() => (disable ? undefined : handleTab(index))}
                  disabled={disable}
                  className={activeTab === index ? 'dashboard-link-active' : 'dashboard-link'}
                >
                  {link}
                </div>
              </div>
            ))}
          </div>
        </CCol>
        {onAddVehicle && (
          <CCol className="text-right p-0" sm="2">
            {title !== 'DA' && (
              <button
                type="button"
                className="btn_Default w-auto mt-0 ps-4 pe-4 h-auto"
                onClick={onAddVehicle}
              >
                Add Vehicles
              </button>
            )}
          </CCol>
        )}
      </CRow>
    </div>
  );
};

export default FleetDashboardTabs;
